import { useCallback } from 'react';
import { useSnackbar } from 'notistack';
import { CustomSnackbar } from 'Shared/CustomSnackbar';

export const copyText = async (text) => {
    if (navigator.clipboard?.writeText) {
        return navigator.clipboard.writeText(text);
    }

    const host = document.activeElement?.closest?.('[role="dialog"]')
        || document.querySelector('[role="dialog"]')
        || document.body;

    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.top = '-1000px';
    host.appendChild(area);
    area.focus();
    area.select();
    const copied = document.execCommand('copy');
    host.removeChild(area);

    if (!copied) {
        throw new Error('Copy is not supported in this browser');
    }
};

export const useCopyText = () => {
    const { enqueueSnackbar } = useSnackbar();

    return useCallback((text, label) => copyText(text)
        .then(() => enqueueSnackbar(`${label} copied to clipboard`, { action: CustomSnackbar, variant: 'success' }))
        .catch(() => enqueueSnackbar(`Unable to copy ${label.toLowerCase()} to clipboard`, { action: CustomSnackbar, variant: 'error' })), [enqueueSnackbar]);
};
